module.exports = __webpack_public_path__ + "img/amount_service.7f1dbedd.jpeg";